import React from "react";
import "./InfoDetails.css";
import { Link } from "react-router-dom";

const InfoAssignDevice = () => {
  return (
    <div className="info-detail">
      <div className="info-hero devices">
        <h2>Equipos y dispositivos</h2>
        <p>
          Cada planta puede asociarse a equipos instalados, configurados
          inicialmente por el equipo central.
        </p>
      </div>

      <section className="info-section">
        <h3>Funciones disponibles</h3>
        <ul>
          <li>Asociar usuarios a dispositivos existentes.</li>
          <li>Activar o desactivar parámetros de cada equipo.</li>
          <li>Crear parámetros calculados a partir de otros datos.</li>
        </ul>
      </section>

      <section className="info-section alt">
        <h3>Objetivo</h3>
        <p>
          Permitir a los usuarios técnicos gestionar y optimizar el uso de
          equipos según las necesidades específicas de cada planta. Configurar parámetros básicos y calculados 
          para un monitoreo eficiente.
        </p>
      </section>

      <section className="info-flow">
        <h3>Flujo de gestión de equipos</h3>
        <ol>
          <li>El sistema lista los <b>equipos disponibles</b> previamente cargados.</li>
          <li>Un usuario con permisos técnicos/administrativos los <b>asocia a la planta</b> deseada.</li>
          <li>Selecciona qué <b>parámetros</b> activar o desactivar según necesidad.</li>
          <li>Opcionalmente, crea <b>parámetros calculados</b> derivados de los existentes.</li>
          <li>El equipo queda operativo y sus datos comienzan a registrarse.</li>
        </ol>
      </section>


      <div className="info-cta">
        <h4>¿Querés configurar un equipo?</h4>
        <Link to="/devices" className="cta-button">
          Ver dispositivos
        </Link>
      </div>
    </div>
  );
};

export default InfoAssignDevice;
